import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './AIModal.css';

/**
 * AI 기능 모달 공통 껍데기.
 *
 * 헤더(.header)가 z-index 로 자체 쌓임 맥락을 만들기 때문에, 헤더 안에서 그대로
 * 렌더하면 본문의 absolute 요소가 모달 위로 올라온다. document.body 로 포털한다.
 */
function AIModalShell({ open, onClose, icon, title, children }) {
  const onKey = useCallback((e) => { if (e.key === 'Escape') onClose(); }, [onClose]);

  useEffect(() => {
    if (!open) return undefined;
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onKey]);

  if (!open) return null;

  return createPortal((
    <div className="aim-overlay" onClick={onClose}>
      <div className="aim-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="aim-head">
          <h2>
            <span className="material-symbols-outlined">{icon}</span>
            {title}
          </h2>
          <div className="aim-head-right">
            <span className="aim-sample-tag">예시 데이터</span>
            <button type="button" className="aim-close" onClick={onClose} aria-label="닫기">
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
        </div>
        <div className="aim-body">{children}</div>
      </div>
    </div>
  ), document.body);
}

export default AIModalShell;
